export default {"src":"/_next/static/media/Wrench.1872bff1.svg","height":60,"width":60};